import service, {clickEventId} from "@irati-tracking/tracker"

const tracking = {
  clickBenefitsCta: (source: string, type: string, perkbox_product: string) => {
    service.trackEvent(clickEventId, {perkbox_product, source, type})
  }
}

export default tracking
